/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PcmsHubJuvenileDemographicProjection { 
    age?: number;
    confinementReleasedDate?: string;
    dateOfBirth?: string;
    email?: string;
    ethnicity?: string;
    firstName?: string;
    gender?: string;
    grantExpectedEndDate?: string;
    guardianAddressCity?: string;
    guardianAddressStateShort?: string;
    guardianAddressStreet?: string;
    guardianAddressUnit?: string;
    guardianAddressZip?: string;
    guardianMobilePhone?: string;
    guardianName?: string;
    guardianPrimaryPhone?: string;
    lastName?: string;
    mobilePhone?: string;
    pcmsIndividualId: number;
    physicalAddressCity?: string;
    physicalAddressStateShort?: string;
    physicalAddressStreet?: string;
    physicalAddressUnit?: string;
    physicalAddressZip?: string;
    population: PcmsHubJuvenileDemographicProjection.PopulationEnum;
    primaryLanguage?: string;
    primaryPhone?: string;
    probationOfficerEmail?: string;
    probationOfficerId?: number;
    probationOfficerName?: string;
    probationOfficerPhone?: string;
    probationStatus?: string;
}
export namespace PcmsHubJuvenileDemographicProjection {
    export const PopulationEnum = {
        Adult: 'ADULT',
        Juvenile: 'JUVENILE'
    } as const;
    export type PopulationEnum = typeof PopulationEnum[keyof typeof PopulationEnum];
}


